import { Pipe, PipeTransform } from '@angular/core';
import { LocalizationService } from '../services/localization.service';

@Pipe({
  standalone: true,
  name: 'localize',
})
export class LocalizePipe implements PipeTransform {
  constructor(private readonly _localization: LocalizationService) {}

  transform(value: string): string {
    return this._localization.localize(value);
  }
}
